// extracted by mini-css-extract-plugin
module.exports = {"container":"orders_container__1sDwf","main":"orders_main__CYvme","main-ltr":"orders_main-ltr__1cdOl","wrapper":"orders_wrapper__3L9Fi"};